export default {
  REACT_APP_ENVOI_API_URI: (window as any)._env_?.REACT_APP_ENVOI_API_URI || process.env.REACT_APP_ENVOI_API_URI,
  REACT_APP_GOOGLE_MAP_URL: (window as any)._env_?.REACT_APP_GOOGLE_MAP_URL || process.env.REACT_APP_GOOGLE_MAP_URL,
  NODE_ENV: (window as any)._env_?.NODE_ENV || process.env.NODE_ENV
}
